import { HugeiconsIcon, IconSvgElement } from "@hugeicons/react";

export const SectionIcon = ({ icon }: { icon: IconSvgElement }) => (
  <HugeiconsIcon icon={icon} size={18} className="text-content-400" />
);
